import * as R from "ramda";

/* pure */
export function fixImageUrl(imageUrl: string): string
export function fixImageUrl(imageUrl?: string): string | undefined
export function fixImageUrl(imageUrl?: string) { 
    return R.isNil(imageUrl) ? undefined : imageUrl.replaceAll("media/", "assets/media/");
}